import { FormGroup, Input, Label } from 'reactstrap';

interface Props {
    password?: string;
    label?: string;
    errors?: boolean;
    propertyName: string;
    onFieldChange: (prop: string, value: string) => void;
}

const Password = (props:Props) => {
    return (
        <FormGroup floating className="mt-3">
            <Input
                id="password"
                name={props.propertyName}
                placeholder="Password"
                type="password"
                onChange={(e) => props.onFieldChange(e.target.name, e.target.value)}
                className={props.errors ? "input-validation-error" : ""} />
            <Label for="password">
                {props.label ? props.label : "Password"}
            </Label>
            {props.errors && <span className="text-danger">Please enter a Password</span>}
        </FormGroup>
    );
}

export default Password;